import { render } from "./BarChartHorizontal.vue?vue&type=template&id=07ae7f40&scoped=true"
import script from "./BarChartHorizontal.vue?vue&type=script&lang=js"
export * from "./BarChartHorizontal.vue?vue&type=script&lang=js"

import "./BarChartHorizontal.vue?vue&type=style&index=0&id=07ae7f40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ae7f40"]])

export default __exports__